import styled from 'styled-components';

export const FeatureMsgWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-items: center;
  height: 100%;
  background: white;
  justify-content: center;
  width: 100%;
`;

export const ContactBtnRow = styled.div`
  display: block;
  text-align: center;
  margin: 1em;
`;

export const FeatureText = styled.div`
  font-size: 22px;
  width: 60%;
`;
